var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cv-checkbox",class:`${_vm.carbonPrefix}--form-item ${_vm.carbonPrefix}--checkbox-wrapper`},[_c('label',{class:`${_vm.carbonPrefix}--checkbox-label ${_vm.carbonPrefix}--skeleton`},[_c('span',{class:`${_vm.carbonPrefix}--checkbox-label-text ${_vm.carbonPrefix}--skeleton`})])])
}
var staticRenderFns = []

export { render, staticRenderFns }